export default {
  document: 1,
  checklist: 1,
};
